import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/service/toast.service';
import { AuthService } from 'src/app/shared/service/auth.service';
import { MESSAGES } from '../constant/messages';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private toast: ToastService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    if (!token) {
      return next.handle(req);
    }

    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const tokenExpired =
          error.error?.listMessage?.includes('Token has expired') ||
          error.error?.message?.includes('Token has expired');

        if (tokenExpired) {
          this.toast.showMessages('warning', ['Tu sesión ha caducado.']);
          this.authService.clear();
          this.router.navigate(['/']);
          return throwError(() => error);
        }

        if (req.url.includes('/logout')) {
          return throwError(() => error);
        }

        if (error.status === 401) {
          const hasRefresh = !!this.authService.getRefreshToken();
          if (!hasRefresh) {
            this.authService.clear();
            this.router.navigate(['/']);
            return throwError(() => error);
          }

          return this.authService.refreshToken().pipe(
            switchMap((newToken) => {
              const retryReq = req.clone({
                setHeaders: { Authorization: `Bearer ${newToken}` },
              });
              return next.handle(retryReq);
            }),
            catchError((refreshErr) => {
              this.authService.clear();
              this.toast.showMessages('error', [
                MESSAGES.GENERAL.SESSION_EXPIRED,
              ]);
              this.router.navigate(['/']);
              return throwError(() => refreshErr);
            })
          );
        }

        if (error.status === 0) {
          this.toast.showMessages('warning', [MESSAGES.GENERAL.BAD_CONNECTION]);
        }

        return throwError(() => error);
      })
    );
  }
}
